import { FC, useMemo } from 'react'
import styles from 'components/features/pfm/CategoriesMenu/CategoriesGroup.styl'
import { CategoryId, MoneyflowCategoryGroup } from 'interfaces/meta'
import { Category } from 'components/features/pfm/CategoriesMenu/Category'


type CategoriesGroupProps = {
  group: MoneyflowCategoryGroup
  selectedId: CategoryId
  allowGroups: boolean
  onSelect?: (selectedId: CategoryId) => void
}
export const CategoriesGroup: FC<CategoriesGroupProps> = (props) => {
  const { group, selectedId, allowGroups, onSelect } = props
  const { id: categoryGroupId, name, categories } = group

  const categoryElements = useMemo(() => categories.map((category) => (
    <Category
      key={ category.id }
      selectedId={ selectedId }
      category={ category }
      onSelect={ onSelect }
    />
  )), [selectedId, categories, onSelect])

  const hintElement = useMemo(() => {
    if (categoryGroupId !== 'transfers') {
      return null
    }

    return (
      <div className={ styles.groupHint }>
        Transfers are excluded from totals.
      </div>
    )
  }, [categoryGroupId])

  if (!allowGroups) {
    return (
      <>
        { categoryElements }
        { hintElement }
      </>
    )
  }

  return (
    <div className={ styles.group }>
      <div className={ styles.groupName }>{ name }</div>
      <div className={ styles.groupList }>
        { categoryElements }
      </div>
      { hintElement }
    </div>
  )
}
